import { parseAbsolute, ZonedDateTime } from '@internationalized/date';
import { win } from '@utils/win';

const validLocales: Record<string, string> = {
  'en-US': 'en-US',
  'en-CA': 'en-CA',
  'fr-CA': 'fr-CA',
  'es-MX': 'es-MX',
};

export function getValidLocale(): string {
  const browserLocale = win.navigator.language;
  if (validLocales[browserLocale]) {
    return browserLocale;
  }
  return 'en-US';
}

export const CURRENT_LOCALE: string = getValidLocale();

export const startOfDay = (zoned: ZonedDateTime): ZonedDateTime => {
  let parsed = zoned;
  // For some implementations of DateRangePicker, there is a lack of granularity on the zoned object that is received. We need to effectively copy the object to increase resolution for the `.set()` method to do anything.
  if (!zoned.hour) {
    const newDate = zoned.toDate();
    parsed = parseAbsolute(newDate.toISOString(), zoned.timeZone);
  }
  return parsed.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
};

export const endOfDay = (zoned: ZonedDateTime): ZonedDateTime => {
  let parsed = zoned;
  // For some implementations of DateRangePicker, there is a lack of granularity on the zoned object that is received. We need to effectively copy the object to increase resolution for the `.set()` method to do anything.
  if (!zoned.hour) {
    const newDate = zoned.toDate();
    parsed = parseAbsolute(newDate.toISOString(), zoned.timeZone);
  }
  return parsed.set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
};

export const addYearsToZoned = (
  zoned: ZonedDateTime,
  years: number,
): ZonedDateTime => {
  return zoned.set({ year: zoned.year + years });
};
